enum LocalStorageKeys {
	authId = 'auth_authId',
	accessTokenLifetime = 'auth_accessTokenLifetime',
	refreshTokenLifetime = 'auth_refreshTokenLifetime',
	lastAuthTimestamp = 'auth_lastAuthTimestamp',
}

export const setAuthId = (authId: string) => {
	localStorage.setItem(LocalStorageKeys.authId, authId);
};
export const getAuthId = () => {
	const authId = localStorage.getItem(LocalStorageKeys.authId);
	// clearAuthId();
	return authId;
};
export const clearAuthId = () => {
	localStorage.removeItem(LocalStorageKeys.authId);
};

export const setAccessTokenLifetime = (accessTokenLifetime: number) => {
	localStorage.setItem(
		LocalStorageKeys.accessTokenLifetime,
		String(accessTokenLifetime),
	);
};
export const getAccessTokenLifetime = () => {
	const accessTokenLifetime = localStorage.getItem(
		LocalStorageKeys.accessTokenLifetime,
	);
	// clearAuthId();
	return accessTokenLifetime ? Number(accessTokenLifetime) : 0;
};
export const clearAccessTokenLifetime = () => {
	localStorage.removeItem(LocalStorageKeys.accessTokenLifetime);
};

export const setRefreshTokenLifetime = (refreshTokenLifetime: number) => {
	localStorage.setItem(
		LocalStorageKeys.refreshTokenLifetime,
		String(refreshTokenLifetime),
	);
};
export const getRefreshTokenLifetime = () => {
	const refreshTokenLifetime = localStorage.getItem(
		LocalStorageKeys.refreshTokenLifetime,
	);
	// clearAuthId();
	return refreshTokenLifetime ? Number(refreshTokenLifetime) : 0;
};
export const clearRefreshTokenLifetime = () => {
	localStorage.removeItem(LocalStorageKeys.refreshTokenLifetime);
};

export const setLastAuthTimestamp = (lastAuthTimestamp: number) => {
	localStorage.setItem(
		LocalStorageKeys.lastAuthTimestamp,
		String(lastAuthTimestamp),
	);
};
export const getLastAuthTimestamp = () => {
	const lastAuthTimestamp = localStorage.getItem(
		LocalStorageKeys.lastAuthTimestamp,
	);
	// clearAuthId();
	return lastAuthTimestamp ? Number(lastAuthTimestamp) : null;
};
export const clearLastAuthTimestamp = () => {
	localStorage.removeItem(LocalStorageKeys.lastAuthTimestamp);
};
